import { useState } from 'react';

import { labelMenu, submenu } from '~/types/constants/labelMenu';

export function useSubmenuState() {
  const [openSubmenus, setOpenSubmenus] = useState<string[]>([]);
  const [selectedSubmenu, setSelectedSubmenu] = useState<string | null>(null);

  function toggleSubmenu(label: string) {
    setOpenSubmenus(prev => {
      if (
        label === labelMenu.campaigns &&
        !prev.includes(labelMenu.campaigns)
      ) {
        return [...prev, labelMenu.campaigns];
      }

      if (label === labelMenu.campaigns && prev.includes(labelMenu.campaigns)) {
        return prev.filter(
          item =>
            item !== labelMenu.campaigns &&
            item !== submenu.banners &&
            item !== submenu.sponsored
        );
      }

      return prev.includes(label)
        ? prev.filter(item => item !== label)
        : [...prev, label];
    });

    setSelectedSubmenu(prev => (prev === label ? null : label));
  }

  function clearSelectedSubmenu() {
    setSelectedSubmenu(null);
  }

  return { openSubmenus, toggleSubmenu, selectedSubmenu, clearSelectedSubmenu };
}
